<template>
  <div class="home">
    <alconPage/>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import alconPage from '@/components/alconPage.vue'; // @ is an alias to /src

export default defineComponent({
  name: 'alconView',
  components: {
    alconPage,
  },
});
</script>
